import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { colors } from '../../constants'

const AbstractBadge = styled.div`
    align-items: center;
    background: ${colors.orange};
    border-radius: 50%;
    box-shadow: -1px 2px 2px 0 ${colors.orange}2c;
    color: ${colors.orangedark};
    font-size: 9px;
    justify-content: center;
    padding: 0 4px;
    position: absolute;
    width: auto;

    ${({ small }) =>
        small
            ? ` height: 10px;
          min-width: 10px;
        `
            : ` height: 15px;
          min-width: 15px;
        `}
`

const FloatingBadge = styled(AbstractBadge)`
    display: flex;
    margin: 0 5px;
    position: absolute;
    right: -5px;
    top: -5px;
`

const InlineBadge = styled(AbstractBadge)`
    display: inline-flex;
    margin: 0 5px;
    position: relative;
    right: 0;
    top: 0;
    vertical-align: middle;
`

function Badge({ children, inline, ...rest }) {
    if (inline) {
        return (
            <InlineBadge small={!children} {...rest}>
                {children}
            </InlineBadge>
        )
    }

    return (
        <FloatingBadge small={!children} {...rest}>
            {children}
        </FloatingBadge>
    )
}

Badge.propTypes = {
    children: PropTypes.node,
    inline: PropTypes.bool,
}

Badge.defaultProps = {
    children: '',
    inline: false,
}

export default Badge
